import switchButton from './domainCard/switchButton'
import setAsMainButton from './domainCard/setAsMainButton'
import modalDeleteDomain from './domainCard/modalDeleteDomain'

export default {
  tagText: {
    main: 'Domínio Principal',
    alternative: 'Domínio Alternativo',
    temporary: 'Domínio Temporário',
    configuration_in_progress: 'Domínio em configuração',
    removing: 'Domínio em remoção',
    unexpected_error: 'Erro de configuração'
  },
  description: {
    main: `Este é o domínio que você comprou.  Se você o excluir, um domínio temporário será
           automaticamente vinculado ao Criador de Sites.`,
    alternative: 'Este é um domínio que você comprou e que aponta para o mesmo site do domínio principal.',
    temporary: `Este é o domínio oferecido pela Locaweb, para ser usado quando não existir um domínio
                próprio.  Se desejar, você pode alterá-lo.`,
    configuration_in_progress: 'Este dominio foi corretamente configurado e levará até 4 horas para se tornar o domínio principal',
    removing: 'Este domínio foi excluído e está em processo de remoção.',
    unexpected_error: 'Ocorreu um erro na configuração deste domínio. Para fazer uma nova tentativa, você deve excluí-lo e em seguida adicioná-lo novamente.'
  },
  switchButton,
  setAsMainButton,
  modalDeleteDomain
}
